import React, { DetailedHTMLProps, forwardRef, HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Container.module.scss';

export interface IContainerProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    size?: 'small' | 'medium' | 'full';
    children?: React.ReactNode;
}

export const Container = forwardRef<HTMLDivElement, IContainerProps>(
    ({ size = 'medium', children, className, ...props }, ref) => {
        return (
            <div ref={ref} className={classNames(styles.container, className, styles[`size-${size}`])} {...props}>
                {children}
            </div>
        );
    },
);
